import PropTypes from 'prop-types';
import React from 'react';
import MenuButton from './menu_button.ui.jsx';
import { routeToManagedDataType } from '../actions/route';
import { connect } from 'react-redux';

const items = [
    { label: 'Add External Link', dataType: 'link' },
    { label: 'Copy Materials', dataType: 'copy-materials' },
    { label: 'Add a Collection', dataType: 'collection' },
];

class ManageContentMenu extends React.Component {
    static displayName = 'ManageContentMenu';

    static propTypes = {
        routeToManagedDataType: PropTypes.func.isRequired,
        currentPath: PropTypes.string.isRequired,
    };

    onSelection = (dataType, event) => {
        this.props.routeToManagedDataType({
            currentPath: this.props.currentPath,
            dataType,
        });
    };

    render() {
        const renderItem = item => (
            <span key={item.dataType}>{item.label}</span>
        );

        return (
            <React.Fragment>
                <span id="manageContentMenuLabel" className="hidden">
                    Manage Content
                </span>
                <MenuButton
                    ariaLabelledBy="manageContentMenuLabel"
                    onSelection={this.onSelection}
                    renderItem={renderItem}
                    items={items}
                >
                    <i className="cl-icon cl-icon-cog" aria-hidden="true" />
                </MenuButton>
            </React.Fragment>
        );
    }
}

export default connect((_, ownProps) => ({ ...ownProps }), {
    routeToManagedDataType,
})(ManageContentMenu);



// WEBPACK FOOTER //
// ./src/components/manage_content_menu.jsx